document.querySelectorAll('.is-bundle .product__description p').forEach(p => {
  if (!p.textContent.trim()) {
    p.remove();
  }
});

jQuery(document).ready(function($) {

  // Slider Arrows on Product Pages
  let isProductPage = $('body').hasClass('template-name-product');
  let isBundle = $('body').hasClass('is-bundle');

  let slideArrows = () => {
    $('.jci-slider-control-buttons .slider-button--prev').click(function() {
      $('.drywater-prev-button').click();
    })
    $('.jci-slider-control-buttons .slider-button--next').click(function() {
      $('.drywater-next-button').click();
    })
  }

  let repositionDescTags = () => {
    let descTags = $('.is-bundle .product__description__tags');
    $('.is-bundle .product__description p').eq(0).after(descTags);
    descTags.attr('style','display: flex;')
  }

let showBundleItems = async () => {
  let variantIds = bundleVariantGids.map(gid => gid.split('/').pop());

  // Split product handles if there are multiple
  let productHandles = bundleVariantProductHandle.split(',');

  // Initialize an array to store all products and variants in order
  let allBundleItems = [];

  for (let handle of productHandles) {
    try {
      // Fetch product data for each handle
      let response = await fetch(`/products/${handle.trim()}.js`);
      let productData = await response.json();

      // Check if the product has variants
      if (productData.variants && productData.variants.length > 0) {
        // Filter variants based on variantIds and preserve order
        const bundleVariants = productData.variants.filter(variant =>
          variantIds.includes(variant.id.toString())
        );

        // Classify as product if "Default Title" is the only option
        bundleVariants.forEach(variant => {
          if (variant.options[0] === "Default Title") {
            allBundleItems.push({
              type: "product",
              product: productData
            });
          } else {
            allBundleItems.push({
              type: "variant",
              product: productData,
              variant: variant
            });
          }
        });
      } else {
        // If no variants, include the product as a standalone item
        allBundleItems.push({
          type: "product",
          product: productData
        });
      }
    } catch (error) {
      console.error(`Error fetching product data for handle ${handle.trim()}:`, error);
    }
  }

  // Define the color mapping for options
  const colorMap = {
    "Lemon Lime": "#FFFF91",
    "Mixed Berry": "#F2AEED",
    "Peach Mango": "#FAC29C"
  };

  // Populate the items into the container
  const container = document.getElementById('bundle-variants-container');
  container.innerHTML = allBundleItems.map(item => {
    if (item.type === "variant") {
      // Handle variant rendering
      const { product, variant } = item;
      const powderColorCode = colorMap[variant.options[0]] || "#CCCCCC"; // Default color

      const variantImage = variant.featured_image
        ? variant.featured_image.src
        : (product.images && product.images[0] ? product.images[0] : '/path-to-default-image.jpg');

      return `
        <div class="bundle-variant">
          <div class="variant-image">
            <img src="${variantImage}" alt="${variant.title}" />
          </div>
          <div class="variant-details">
            <h4 class="variant-title">${product.title}</h4>
            <p class="variant-pack">1 Pouch (${variant.options[1].replaceAll(' pack','')} stick packs)</p>
            <div class="variant-option">
              <div class="powder-color-code" style="background-color:${powderColorCode}; width: 16px; height: 16px; border-radius: 50%; display: inline-block; margin-right: 8px;"></div>
              ${variant.options[0]}
            </div>
          </div>
        </div>
      `;
    } else if (item.type === "product") {
      // Handle standalone product rendering
      const { product } = item;

      const productImage = product.images && product.images[0]
        ? product.images[0]
        : '/path-to-default-image.jpg';

      return `
        <div class="bundle-variant">
          <div class="variant-image">
            <img src="${productImage}" alt="${product.title}" />
          </div>
          <div class="variant-details">
            <h4 class="variant-title">${product.title}</h4>
            <p class="variant-pack">FREE</p>
          </div>
        </div>
      `;
    }
  }).join('');

  document.querySelector('#bundle-variants-container > img').remove();
};

let bundlePhotoCarousel = () => {

  const container = $('#photo-carousel-container');

  // Extract media image IDs from the metafield GIDs
  const imageIds = bundlePhotoCarousel.map(gid => gid.split('/').pop());

  // Fetch image URLs from the Shopify CDN
  const imageUrls = imageIds.map(
    id => `https://cdn.shopify.com/s/files/1/your-store-id/files/${id}.jpg` // Update with your store's actual CDN path
  );

  // Render images into the container
  if (imageUrls.length > 0) {
    const fullWidthImage = `
      <div class="carousel-image full-width">
        <img src="${imageUrls[0]}" alt="Bundle Image 1">
      </div>
    `;

    const halfWidthImages = `
      <div class="carousel-images-row">
        <div class="carousel-image half-width">
          <img src="${imageUrls[1] || '/path-to-placeholder.jpg'}" alt="Bundle Image 2">
        </div>
        <div class="carousel-image half-width">
          <img src="${imageUrls[2] || '/path-to-placeholder.jpg'}" alt="Bundle Image 3">
        </div>
      </div>
    `;

    // Append the images to the container
    container.append(fullWidthImage + halfWidthImages);
  }

  
}







  if(isProductPage) {
    slideArrows();
  }

  if(isBundle) {
    showBundleItems();
    repositionDescTags();
  }
});